export enum UserRole {
  SUPERADMIN = "SUPERADMIN",
  DIRECTOR_TECH = "DIRECTOR_TECH",
  TECH = "TECH",
  CLIENT = "CLIENT",
}

export enum DrillMode {
  REAL = "REAL",
  MANUAL = "MANUAL",
}

export enum WorkflowState {
  DRAFT = "DRAFT",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  TRASHED = "TRASHED",
}

export enum RecipientRole {
  TECH = "TECH",
  CLIENT = "CLIENT",
}
